
class MvCarouselTitles {
  private carouselTitlesEl:HTMLElement;
  private carouselTitleEls:NodeList;
  private currentTitleEl:HTMLElement;

  constructor() {
    this.carouselTitlesEl = document.querySelector('#mvCarouselTitles');
    this.carouselTitleEls = this.carouselTitlesEl.querySelectorAll('.mv__carousel-title');
    this.currentTitleEl = this.carouselTitleEls[0] as HTMLElement;
    
    this.setHeight();
    this.init();


  }

  init() {
    this.currentTitleEl.classList.add('-in');
    this.goto(0);

    let resizeTimer;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer); // 既存のタイマーをクリア
      resizeTimer = setTimeout(() => {
        this.setHeight();
      }, 500);
    });
  }

  getMaxHeight() {
    //.mv__carousel-titleの中で最も高い要素の高さを取得
    const titleEls = this.carouselTitlesEl.querySelectorAll('.mv__carousel-title');
    let maxHeight = 0;
    titleEls.forEach(titleEl => {
      const height = titleEl.clientHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    return maxHeight;
  }

  setHeight() {
    const maxHeight = this.getMaxHeight();
    this.carouselTitlesEl.style.height = `${maxHeight}px`;
  }

  standby() {
    this.carouselTitleEls.forEach((titleEl:HTMLElement) => {
      titleEl.classList.add('-standby');
      titleEl.classList.remove('-in');
      titleEl.classList.remove('-out');
    });
  }

  goto(index:number){
    this.currentTitleEl.classList.add('-out');
    this.currentTitleEl.classList.remove('-in');
    this.currentTitleEl.classList.remove('-standby');

    setTimeout(() => {
      this.standby();
      this.currentTitleEl = this.carouselTitleEls[index] as HTMLElement;
      this.currentTitleEl.classList.remove('-standby');
      this.currentTitleEl.classList.add('-in');
    }, 300);

  }
}

export default MvCarouselTitles;

